import React from 'react';
import ReactExport from 'react-export-excel';

import Button from '../../../../components/Button';
import { DashboardChartBox, HeaderTitle } from '../styles';

interface RawTiming {
  pageNo: number;
  time: number;
  resultId: number;
}

interface RawTimingDataTableProps {
  rawTimings: RawTiming[];
  formatTime: (ms: number) => string;
}

const { ExcelFile } = ReactExport;
const { ExcelSheet } = ReactExport.ExcelFile;
const { ExcelColumn } = ReactExport.ExcelFile;

const RawTimingDataTable: React.FC<RawTimingDataTableProps> = ({
  rawTimings,
  formatTime,
}) => {
  const preview = rawTimings.slice(0, 20);
  return (
    <DashboardChartBox>
      <div style={{ flex: 1, flexDirection: 'column', display: 'flex' }}>
        <HeaderTitle>
          <p>Raw Timing Data</p>
        </HeaderTitle>
        <div style={{ marginBottom: 16 }}>
          <ExcelFile
            element={
              <Button $marginRight="16px" $width="200px" $height="36px">
                Export all data to Excel
              </Button>
            }
            filename={`RawTimingData-${new Date().toISOString()}`}
          >
            <ExcelSheet data={rawTimings} name="RawTimingData">
              <ExcelColumn label="Respondent ID" value="resultId" />
              <ExcelColumn label="Page Number" value="pageNo" />
              <ExcelColumn label="Time Spent (ms)" value="time" />
            </ExcelSheet>
          </ExcelFile>
        </div>
        <h4 style={{ marginBottom: '16px' }}>
          Preview List (20 records max):{' '}
        </h4>
        <table className="styled-table">
          <thead>
            <tr>
              <th>Respondent ID</th>
              <th>Page Number</th>
              <th>Time Spent</th>
            </tr>
          </thead>
          <tbody>
            {preview.map((item, index) => (
              <tr key={`raw-${item.resultId}-${item.pageNo}-${index}`}>
                <td>{item.resultId}</td>
                <td>{item.pageNo}</td>
                <td>{formatTime(item.time)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </DashboardChartBox>
  );
};

export default RawTimingDataTable;
